import { TextField, TextInput } from "react-admin";
import BusinessIcon from "@mui/icons-material/Business";
import { RecordSummary, MyShow } from "../ra-lb-tools/components/MyShow";
import { MyList } from "../ra-lb-tools/components/myList";
import { MyEdit as Edit, MyCreate } from "../ra-lb-tools/components/myMutator";
import { LabeledColumn } from "../ra-lb-tools/components/labeledColumn";
import {
  MyTabbedShowLayout,
  Tab,
} from "../ra-lb-tools/components/myTabbedShowLayout";
import { DeviceField, DeviceInput } from "./devices";

export const DeviceAssemblyIcon = BusinessIcon;

export const DeviceAssemblyList = (props) => (
  <MyList resource="device-assembly" {...props}>
    <TextField source="id" />
    <DeviceField source="deviceId" />
    <TextField source="shield1MfgSerial" />
    <TextField source="shield2MfgSerial" />
    <TextField source="particleId" />
  </MyList>
);

export const DeviceAssemblyShow = () => {
  return (
    <MyShow>
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary sx={{ justifyContent: "start" }}>
            <LabeledColumn>
              <TextField source="id" />
              <DeviceField source="deviceId" />
              <TextField source="shield1MfgSerial" />
              <TextField source="shield2MfgSerial" />
              <TextField source="particleId" />
            </LabeledColumn>
          </RecordSummary>
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};

export const DeviceAssemblyEdit = () => (
  <Edit columns={1}>
    <DeviceInput source="deviceId" />
    <TextInput source="shield1MfgSerial" />
    <TextInput source="shield2MfgSerial" />
    <TextInput source="particleId" />
  </Edit>
);

export const DeviceAssemblyCreate = () => (
  <MyCreate columns={1}>
    <DeviceInput source="deviceId" />
    <TextInput source="shield1MfgSerial" />
    <TextInput source="shield2MfgSerial" />
    <TextInput source="particleId" />
  </MyCreate>
);
